import { S3_IMAGES_URL } from '../../../constants';

export const PLANETS = [
  {
    id: 1,
    src: `${S3_IMAGES_URL}main_screen_planets/planet-1@3x.png`,
    speed: 2,
  },
  {
    id: 2,
    src: `${S3_IMAGES_URL}main_screen_planets/planet-2@3x.png`,
    speed: 3,
  },
  {
    id: 3,
    src: `${S3_IMAGES_URL}main_screen_planets/planet-3@3x.png`,
    speed: 2,
  },
  {
    id: 4,
    src: `${S3_IMAGES_URL}main_screen_planets/planet-4@3x.png`,
    speed: 3,
  },
  {
    id: 5,
    src: `${S3_IMAGES_URL}main_screen_planets/planet-5@3x.png`,
    speed: 2,
  },
];
